module.exports = __webpack_public_path__ + "img/mombasa2.9a7510e8.jpg";